if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        viewerSlider: this.querySelector('[id^="Slider-Gallery"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.currentCounter =
        this.closest('product-info')?.querySelector('.slider-counter--current') ||
        this.querySelector('.slider-counter--current');
      this.totalCounter =
        this.closest('product-info')?.querySelector('.slider-counter--total') ||
        this.querySelector('.slider-counter--total');

      this.variantMediaMap = null;
      this.pdpInstance = null;


      if (this.elements.viewer) {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      }

      this.zoomTrigger = this.querySelector('[data-product-gallery-zoom-trigger]');
      if (this.zoomTrigger) {
        this.zoomTrigger.addEventListener('click', this.openActiveMedia.bind(this));
      }

      // Ensure mobile thumb-slide updates counter & active media even when slider-component isn't initialized
      if (this.elements.viewerSlider) {
        this.elements.viewerSlider.addEventListener(
          'scroll',
          debounce(this.onViewerScroll.bind(this), 200)
        );
      }

      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener(
            'click',
            () => {
            const mediaId = mediaToSwitch.dataset.target;
            this.setActiveMedia(mediaId, false);
            this.syncVariantFromMedia(mediaId);
          }
          );
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
    }

    
    syncVariantFromMedia(mediaId) {
      if (!mediaId || !this.id) return;
      try {
        // Lazily resolve PDPSuite instance and build media->variant map once per gallery
        if (!this.pdpInstance || !this.variantMediaMap) {
          const sectionId = this.id.replace('MediaGallery-', '');
          if (!sectionId) return;

          const root = document.querySelector(`.pdp-suite[data-section-id="${sectionId}"]`);
          if (!root || !root.__pdpSuite) return;

          const pdp = root.__pdpSuite;
          const product = pdp.product || {};
          const variants = Array.isArray(product.variants) ? product.variants : [];

          const map = {};
          variants.forEach((v) => {
            if (v && v.featured_media && v.featured_media.id != null) {
              map[String(v.featured_media.id)] = v;
            }
          });

          this.pdpInstance = pdp;
          this.variantMediaMap = map;
        }

        const pdp = this.pdpInstance;
        const map = this.variantMediaMap || {};
        const match = map[String(mediaId)];
        if (!match) return;

        // Avoid re-applying the same variant
        if (pdp.currentVariant && String(pdp.currentVariant.id) === String(match.id)) return;

        // Try to update the visible selects to match this variant
        if (Array.isArray(match.options) && Array.isArray(pdp.selects)) {
          pdp.selects.forEach((sel, index) => {
            const val = match.options[index];
            if (!val) return;
            const opt = Array.from(sel.options || []).find((o) => o.value === val);
            if (opt) {
              sel.value = opt.value;
            }
          });
          const lastSel = pdp.selects[pdp.selects.length - 1];
          if (lastSel) {
            lastSel.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }

        // Fallback: apply variant directly
        if (typeof pdp.applyVariant === 'function') {
          pdp.applyVariant(match, { push: true });
        }
      } catch (e) {
        console.warn('[PDP Gallery] syncVariantFromMedia error', e);
      }
    }

onViewerScroll() {
      if (!this.elements.viewerSlider) return;

      const slider = this.elements.viewerSlider;
      const slides = Array.from(slider.querySelectorAll('[data-media-id]'));
      if (!slides.length) return;

      const scrollLeft = slider.scrollLeft;
      const sliderCenter = scrollLeft + slider.clientWidth / 2;

      let closestSlide = slides[0];
      let minDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide) => {
        const center = slide.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(center - sliderCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestSlide = slide;
        }
      });

      if (!closestSlide || !closestSlide.dataset.mediaId) return;

      const mediaId = closestSlide.dataset.mediaId;
      this.setActiveMedia(mediaId, false);
      this.syncVariantFromMedia(mediaId);
    }

    openActiveMedia() {
      if (!this.elements.viewer) return;
      const activeMedia =
        this.elements.viewer.querySelector('.product__media-item.is-active') ||
        this.elements.viewer.querySelector('[data-media-id]');
      const toggle = activeMedia && activeMedia.querySelector('.product__media-toggle');
      if (toggle) toggle.click();
    }

    onSlideChanged(event) {
      const currentElement = event.detail.currentElement;
      if (!currentElement || !currentElement.dataset.mediaId) return;

      const mediaId = currentElement.dataset.mediaId;

      // Ensure gallery state & counter stay in sync with slider
      this.setActiveMedia(mediaId, false);

      if (!this.elements.thumbnails) return;

      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${ mediaId }"]`
      );
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
            // Update single slider counter (current / total) if present
      const allItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
      const uniqueIds = [];
      const uniqueItems = [];
      allItems.forEach((el) => {
        const id = el.dataset.mediaId;
        if (!uniqueIds.includes(id)) {
          uniqueIds.push(id);
          uniqueItems.push(el);
        }
      });
      const activeId = activeMedia.dataset.mediaId;
      const index = uniqueIds.indexOf(activeId);

      let currentCounter = this.currentCounter;
      let totalCounter = this.totalCounter;

      if (!currentCounter || !totalCounter) {
        currentCounter =
          this.closest('product-info')?.querySelector('.slider-counter--current') ||
          this.querySelector('.slider-counter--current');
        totalCounter =
          this.closest('product-info')?.querySelector('.slider-counter--total') ||
          this.querySelector('.slider-counter--total');
        this.currentCounter = currentCounter;
        this.totalCounter = totalCounter;
      }

      if (currentCounter && index !== -1) {
        currentCounter.textContent = String(index + 1);
      }
      if (totalCounter && uniqueItems.length > 0) {
        totalCounter.textContent = String(uniqueItems.length);
      }

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
